export default {
  NAMESPACE: 'queue/items'
}
